import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoutes from './protectedRoutes';
import AuthRoutes from './authRoutes';
import adminRoutes from './adminRoutes';

// routes

// import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //
const useRouterProvider = () => {
  return createBrowserRouter([AuthRoutes, ProtectedRoutes, adminRoutes], {
    basename: process.env.REACT_APP_BASE_NAME,
  });
};
export default useRouterProvider;
